@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.contentWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
  padding: 8px 0;
}

.ticker {
  display: flex;
  flex-direction: row;
  min-width: 0;
  overflow: hidden;
}

.leftImageContainer {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.titleContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  @include typography-v2-body-md;
}

.nameRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.entityName {
  flex: 1;
  min-width: 0;
  overflow: hidden;

  span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tag {
  color: var(--text-soft);
  text-transform: uppercase;
  align-items: center;
  margin: 0;
  @include typography-v2-body-xs;
}

.watchlistButton {
  @include border-radius-full;
  aspect-ratio: 1;
}

.watchlistButtonActive {
  color: var(--text-success);
  border-color: var(--border-success);
  background-color: var(--surface-success);

  svg {
    fill: var(--icon-success);
  }
}
